import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 足球 杯赛
import footballCupRouter from '@router/football/cup_commonRouter'

// FIFAWC|世界杯
import footballCup_FIFAWCRouter from '@router/football/cup_FIFAWC'
// FIFAWCQ AZ|世界杯亚洲区预选赛
import footballCup_FIFAWCQAZRouter from '@router/football/cup_FIFAWCQAZ'

const {
  FootballCupScheduleIndex,
  FootballAsianPreCupScheduleIndex,
  FootballCupScheduleDetailIndex,
  FootballCupScheduleDetailPreMatch,
  FootballCupScheduleDetailLineup,
  FootballCupScheduleDetailAIForwardLooking,
  FootballCupScheduleDetailAnalysis,
  FootballCupScheduleDetailStatistics,
  FootballCupTeamIndex,
  FootballCupTeamDetailIndex,
  FootballCupTeamDetailTeamData,
  FootballCupTeamDetailPlayerList,
  FootballCupTeamDetailMatchRecord,
  FootballCupLeagueTableIndex,
  FootballCupKnockoutRoundsIndex,
  FootballCupRecordDataOverviewIndex,
  FootballCupRecordTeamDataIndex,
  FootballCupRecordPlayerDataIndex,
  FootballCupPlayerIndex,
  FootballCupPlayerDetailIndex,
  FootballCupSportsHallIndex,
  FootballCupBroadcastListIndex,
  FootballCupDataPackagListIndex,
  FootballCupProgramListIndex,
  FootballCupH5CompIndex,
} = footballCupRouter
const { PlatfromFootballFIFAWCFull } = footballCup_FIFAWCRouter
const { PlatfromFootballFIFAWCQAZFull } = footballCup_FIFAWCQAZRouter

const pathModuleBase = 'platfromFootballCupFull'
const diffCompetitionTypeArr = [
  {
    name: 'FIFAWC',
    pathModule: 'FIFAWorldCup',
    component: PlatfromFootballFIFAWCFull,
  }, // 世界杯
  {
    name: 'FIFAWCQAZ',
    pathModule: 'WCQAsianZone',
    component: PlatfromFootballFIFAWCQAZFull,
  }, // 世界杯亚洲区预选赛
]

const baseChildren = [
  // pathModule 默认占位是FIFAWC
  {
    path: 'schedule', //football/cup/赛程
    name: 'scheduleIndex', // 最终生成的name是 'scheduleIndex_FIFAWC'
    component: FootballCupScheduleIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'zonePreSchedule', //football/亚洲世预赛/赛程
    name: 'zonePreScheduleIndex',
    component: FootballAsianPreCupScheduleIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'scheduleDetail', //football/cup/赛程详情
    redirect: { name: 'scheduleDetailPreMatch' },
    name: 'scheduleDetailIndex',
    component: FootballCupScheduleDetailIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'AIForwardLooking', //football/cup/赛程详情-AI前瞻
        name: 'scheduleDetailAIForwardLooking',
        component: FootballCupScheduleDetailAIForwardLooking,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'preMatch', //football/cup/赛程详情-赛前
        name: 'scheduleDetailPreMatch',
        component: FootballCupScheduleDetailPreMatch,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'lineup', //football/cup/赛程详情-阵容
        name: 'scheduleDetailLineup',
        component: FootballCupScheduleDetailLineup,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'analysis', //football/cup/赛程详情-数据分析
        name: 'scheduleDetailAnalysis',
        component: FootballCupScheduleDetailAnalysis,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'statistics', //football/cup/赛程详情-数据统计
        name: 'scheduleDetailStatistics',
        component: FootballCupScheduleDetailStatistics,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
    ],
  },
  {
    path: 'team', //football/cup/球队
    name: 'teamIndex',
    component: FootballCupTeamIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'team'],
      requireLogin: false,
      title: '球队',
    },
  },
  {
    path: 'teamDetail', //football/cup/球队详情
    redirect: { name: 'teamDetailTeamData' },
    name: 'teamDetailIndex',
    component: FootballCupTeamDetailIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'team'],
      requireLogin: false,
    },
    children: [
      {
        path: 'teamData', //football/cup/球队详情-数据
        name: 'teamDetailTeamData',
        component: FootballCupTeamDetailTeamData,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'playerList', //football/cup/球队详情-名单
        name: 'teamDetailPlayerList',
        component: FootballCupTeamDetailPlayerList,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchRecord', //football/cup/球队详情-比赛记录
        name: 'teamDetailMatchRecord',
        component: FootballCupTeamDetailMatchRecord,
        meta: {
          pathModule: ['football', 'FIFAWorldCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
    ],
  },
  {
    path: 'leagueTable', //football/cup/积分榜
    name: 'leagueTableIndex',
    component: FootballCupLeagueTableIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'leagueTable'],
      requireLogin: false,
      title: '积分榜',
    },
  },
  {
    path: 'knockoutRounds', //football/cup/淘汰赛
    name: 'knockoutRoundsIndex',
    component: FootballCupKnockoutRoundsIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'knockoutRounds'],
      requireLogin: false,
      title: '淘汰赛',
    },
  },
  {
    path: 'recordDataOverview', //football/cup/数据-数据概览
    name: 'recordDataOverviewIndex',
    component: FootballCupRecordDataOverviewIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'record'],
      requireLogin: false,
      title: '数据',
    },
  },
  {
    path: 'recordTeamData', //football/cup/数据-球队数据
    name: 'recordTeamDataIndex',
    component: FootballCupRecordTeamDataIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'record'],
      requireLogin: false,
      title: '数据',
    },
  },
  {
    path: 'recordPlayerData', //football/cup/数据-球员数据
    name: 'recordPlayerDataIndex',
    component: FootballCupRecordPlayerDataIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'record'],
      requireLogin: false,
      title: '数据',
    },
  },
  {
    path: 'player', //football/cup/球员
    name: 'playerIndex',
    component: FootballCupPlayerIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'player'],
      requireLogin: false,
      title: '球员',
    },
  },
  {
    path: 'playerDetail', //football/cup/球员详情
    name: 'playerDetailIndex',
    component: FootballCupPlayerDetailIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'player'],
      requireLogin: false,
      title: '球员详情',
    },
  },
  {
    path: 'sportsHall', //足球 杯赛-场馆
    name: 'sportsHallIndex',
    component: FootballCupSportsHallIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'sportsHall'],
      requireLogin: false,
      title: '场馆',
    },
  },
  {
    path: 'broadcastList', //足球 杯赛-播出单
    name: 'broadcastListIndex',
    component: FootballCupBroadcastListIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //数据包装
    name: 'dataPackagListIndex',
    component: FootballCupDataPackagListIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'programListIndex',
    component: FootballCupProgramListIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
  {
    path: 'h5Comp', //足球 h5组件
    name: 'h5CompIndex',
    component: FootballCupH5CompIndex,
    meta: {
      pathModule: ['football', 'FIFAWorldCup', 'h5Comp'],
      requireLogin: false,
      title: 'h5组件',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /FIFAWorldCup
  name: `${pathModuleBase}_${routerItem.name}`, // platfromFootballCupFull_FIFAWC
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default {
  football_FIFAWC_RouterMode: routerModeArr[0],
  football_FIFAWCQAZ_RouterMode: routerModeArr[1],
}
